module.exports = __webpack_public_path__ + "img/patient-landing-patient-centered-care.58cf84b6.svg";